import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import app from 'flarum/common/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import PointsLeaderboardListItem from "./PointsBoardListItem";

export default class PointsLeaderboardWidget extends Widget {

  oninit(vnode) {
    super.oninit(vnode);
    this.maxLoadCount = app.forum.attribute("tf-points.leaderboardMaxLoadCount") || 10;
    this.initloadCount = app.forum.attribute("tf-points.leaderboardInitLoadCount") || 10;
    this.pointsBoardList ??= [];
    this.groupBoardList ??= [];
    this.totalLoadCount = 0;
    this.moreResults = false;
    this.activeTab = 'personal'; // 'personal' | 'group'
    this.period = 'alltime'; // alltime | week | month | year
    this.periodOpen = false; // dropdown state
    this.tabOpen = false; // tab dropdown state

    this.attrs.state.isLoading ??= true;
    this.attrs.state.hasLoaded ??= false;
    
    // Only load if leaderboard is enabled
    if (app.forum.attribute("tf-points.leaderboardEnabled") !== false) {
      // 默认加载版主排行榜 (alltime-personal)
      if (this.activeTab === 'group') {
        this.loadGroupResults();
      } else {
        this.loadResults(0, this.initloadCount);
      }
    } else {
      this.attrs.state.isLoading = false;
    }
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  className() {
    return 'tf-points-leaderboardWidget';
  }

  icon() {
    return 'fa-light fa-star';
  }

  title() {
    // return app.translator.trans('tf-points.forum.leaderboard-name');
    return '';
  }

  description() {
    return '';
  }

  content() {
    let rankID = 0;
    let loading;
    if (this.attrs.state.isLoading) {
      loading = <LoadingIndicator />;
    }

    const periodLabel = () => {
      switch (this.period) {
        // case 'day': return app.translator.trans('tf-points.forum.leaderboard-period-day') || 'Day';
        case 'week': return app.translator.trans('tf-points.forum.leaderboard-period-week');
        case 'month': return app.translator.trans('tf-points.forum.leaderboard-period-month');
        // case 'quarter': return app.translator.trans('tf-points.forum.leaderboard-period-quarter') || 'Quarter';
        case 'year': return app.translator.trans('tf-points.forum.leaderboard-period-year');
        default: return app.translator.trans('tf-points.forum.leaderboard-period-all-time');
      }
    };

    const renderHeader = () => (
      <div className="TLHeader">
        <div className="TLHeader-title">{app.translator.trans('tf-points.forum.leaderboard-top-creators')}</div>
        <div className="TLHeader-filters">
          <div className="TLHeader-periodDropdown">
            <button className="Button Button--link TLHeader-filterBtn" onclick={() => { this.periodOpen = !this.periodOpen; this.tabOpen = false; m.redraw(); }}>
              {periodLabel()} <i class="fa-light fa-chevron-down"></i>
            </button>
            {this.periodOpen && (
              <ul className="TLHeader-menu">
                {['alltime','week','month','year'].map(key => (
                  <li>
                    <button className={`Button Button--link TLHeader-menuItem ${this.period === key ? 'is-active' : ''}`}
                      onclick={() => {
                        this.period = key;
                        this.periodOpen = false;
                        // reset and reload data based on current tab
                        if (this.activeTab === 'group') {
                          this.groupBoardList = [];
                          this.attrs.state.isLoading = true;
                          this.loadGroupResults();
                        } else {
                          this.pointsBoardList = [];
                          this.totalLoadCount = 0;
                          this.attrs.state.isLoading = true;
                          this.attrs.state.hasLoaded = false;
                          this.loadResults(0, this.initloadCount);
                        }
                      }}>{
                        key === 'alltime' ? app.translator.trans('tf-points.forum.leaderboard-period-all-time') :
                        key === 'week' ? app.translator.trans('tf-points.forum.leaderboard-period-week') :
                        key === 'month' ? app.translator.trans('tf-points.forum.leaderboard-period-month') :
                        app.translator.trans('tf-points.forum.leaderboard-period-year')
                      }</button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="TLHeader-tabDropdown">
            <button className="Button Button--link TLHeader-filterBtn" onclick={() => { this.tabOpen = !this.tabOpen; this.periodOpen = false; m.redraw(); }}>
              {this.activeTab === 'personal' ? app.translator.trans('tf-points.forum.leaderboard-tab-moderators') : 
               this.activeTab === 'users' ? app.translator.trans('tf-points.forum.leaderboard-tab-users') :
               app.translator.trans('tf-points.forum.leaderboard-tab-groups')} <i class="fa-light fa-chevron-down"></i>
            </button>
            {this.tabOpen && (
              <ul className="TLHeader-menu">
                <li>
                  <button className={`Button Button--link TLHeader-menuItem ${this.activeTab === 'personal' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'personal') {
                        this.activeTab = 'personal';
                        this.tabOpen = false;
                        // 切换标签时，user_type 参数不同，需要清空数据并重新加载
                        this.pointsBoardList = [];
                        this.totalLoadCount = 0;
                        this.attrs.state.isLoading = true;
                        this.attrs.state.hasLoaded = false;
                        this.groupBoardList = [];
                        this.loadResults(0, this.initloadCount);
                        m.redraw();
                      }
                    }}>{app.translator.trans('tf-points.forum.leaderboard-tab-moderators')}</button>
                </li>
                <li>
                  <button className={`Button Button--link TLHeader-menuItem ${this.activeTab === 'users' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'users') {
                        this.activeTab = 'users';
                        this.tabOpen = false;
                        // 切换标签时，user_type 参数不同，需要清空数据并重新加载
                        this.pointsBoardList = [];
                        this.totalLoadCount = 0;
                        this.attrs.state.isLoading = true;
                        this.attrs.state.hasLoaded = false;
                        this.groupBoardList = [];
                        this.loadResults(0, this.initloadCount);
                        m.redraw();
                      }
                    }}>{app.translator.trans('tf-points.forum.leaderboard-tab-users')}</button>
                </li>
                <li>
                  <button className={`Button Button--link TLHeader-menuItem ${this.activeTab === 'group' ? 'is-active' : ''}`}
                    onclick={() => {
                      if (this.activeTab !== 'group') {
                        this.activeTab = 'group';
                        this.tabOpen = false;
                        // 如果有数据，保留数据不显示 loading，在后台加载新数据
                        // 如果没有数据，清空并显示 loading
                        const hasData = this.groupBoardList && this.groupBoardList.length > 0;
                        if (!hasData) {
                          this.groupBoardList = [];
                          this.attrs.state.isLoading = true;
                        }
                        this.pointsBoardList = [];
                        this.totalLoadCount = 0;
                        this.loadGroupResults();
                        m.redraw();
                      }
                    }}>{app.translator.trans('tf-points.forum.leaderboard-tab-groups') || 'Groups'}</button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    );

    const renderTabs = () => null; // Tabs are now in header as dropdown buttons

    const renderAvatar = (item) => {
      const url = item?.attributes?.avatarUrl;
      const name = item?.attributes?.displayName || item?.attributes?.username || '';
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      if (url) {
        return <img className="TLAvatar-img" src={url} alt={name} />;
      }
      return <div className="TLAvatar-fallback">{initial}</div>;
    };

    const renderGroupAvatar = (item) => {
      const a = item?.attributes || item;
      const coverImage = a?.cover_image;
      const name = a?.name || 'Group';
      const initial = (name || '?').toString().charAt(0).toUpperCase();
      const baseUrl = app.forum.attribute('baseUrl') || '';
      const coverUrl = coverImage ? `${baseUrl}/${coverImage}` : null;
      
      if (coverUrl) {
        return <img className="TLAvatar-img" src={coverUrl} alt={name} />;
      }
      return <div className="TLAvatar-fallback">{initial}</div>;
    };

    const renderPersonalItem = (item, idx) => {
      const name = item?.attributes?.displayName || item?.attributes?.username || 'Unknown';
      const pts = item?.attributes?.remote_points || 0;
      const rank = idx + 1;
      const nameCls = rank <= 3 ? 'TLName top' : 'TLName';
      return (
        <li class="TLItem">
          <div class="TLRank">{rank}</div>
          <div class="TLAvatar">{renderAvatar(item)}</div>
          <div class={nameCls}>{name}</div>
          <div class="TLPoints">{pts} {app.translator.trans('tf-points.forum.leaderboard-points-text')}</div>
        </li>
      );
    };

    const renderGroupItem = (item, idx) => {
      const a = item?.attributes || item;
      const name = a?.name || 'Group';
      const heat = a?.heat_total || 0;
      const rank = idx + 1;
      const nameCls = rank <= 3 ? 'TLName top' : 'TLName';
      return (
        <li class="TLItem">
          <div class="TLRank">{rank}</div>
          <div class="TLAvatar">{renderGroupAvatar(item)}</div>
          <div class={nameCls}>{name}</div>
          <div class="TLPoints">{heat}</div>
        </li>
      );
    };

    const renderShowAll = () => {
      const tab = this.activeTab === 'personal' ? 'moderators' : this.activeTab;
      const q = new URLSearchParams();
      q.set('period', this.period);
      q.set('tab', tab);
      const url = app.route('pointsLeaderboard') + '?' + q.toString();
      return (
        <div className="TLShowAll">
          <a href={url} className="Button TLShowAll-btn">{app.translator.trans('tf-points.forum.leaderboard-show-all')}</a>
        </div>
      );
    };

    return (
      <div>
      <div className="tf-points-board-widget">
        {renderHeader()}
        <div class="PointsBoardContainer">
          
          {renderTabs()}
          <ol class="TLList">
            {this.activeTab === 'group'
              ? this.groupBoardList.slice(0, 10).map((g, i) => renderGroupItem(g, i))
              : this.pointsBoardList.slice(0, 10).map((u, i) => renderPersonalItem(u, i))}
          </ol>
          {loading && <div className="PointsLeaderboard-loadMore">{loading}</div>}
        
        </div>
      
      </div>
        {!loading && renderShowAll()}
        </div>
    );
  }

  parseResults(results) {
    try {
      // Check if results is valid and has the expected structure
      if (!results) {
        console.warn('No results received from API');
        this.attrs.state.isLoading = false;
        m.redraw();
        return;
      }

      // Handle different result formats
      let data = [];
      if (results.data && Array.isArray(results.data)) {
        // Standard API response format: {data: [...], links: {...}}
        data = results.data;
        this.moreResults = !!results.links && !!results.links.next;
      } else if (results.payload && Array.isArray(results.payload.data)) {
        // Alternative format: {payload: {data: [...], links: {...}}}
        data = results.payload.data;
        this.moreResults = !!results.payload.links && !!results.payload.links.next;
      } else if (Array.isArray(results)) {
        // Direct array format
        data = results;
        this.moreResults = false;
      } else {
        console.warn('Unexpected results format:', results);
        this.attrs.state.isLoading = false;
        m.redraw();
        return;
      }

      // Add results to the list
      if (Array.isArray(data) && data.length > 0) {
        // Ensure data is properly formatted as Flarum user objects
        const formattedData = data.map(item => {
          if (item.data) {
            return item.data;
          } else if (item.attributes) {
            return item;
          } else {
            return item;
          }
        });
        [].push.apply(this.pointsBoardList, formattedData);
      }

      this.attrs.state.isLoading = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing results:', error);
      this.attrs.state.isLoading = false;
      m.redraw();
    }
  }

  loadResults(offset = 0, loadCount = 20) {
    if (this.maxLoadCount === this.totalLoadCount) {
      return;
    }

    // 如果已有数据，不显示 loading，在后台加载新数据
    const hasData = this.pointsBoardList && this.pointsBoardList.length > 0;
    if (!hasData && !this.attrs.state.isLoading) {
      this.attrs.state.isLoading = true;
    }

    let limit = loadCount;

    if (this.maxLoadCount < this.totalLoadCount + loadCount) {
      limit = this.maxLoadCount - this.totalLoadCount;
      this.totalLoadCount = this.maxLoadCount;
    }

    this.totalLoadCount += loadCount;

    // 根据标签确定 user_type 参数
    const userType = this.activeTab === 'personal' ? 'owner' : 'normal';

    return app.store
      .find("pointsboard", {
        page: {
          offset,
          limit
        },
        period: this.period,
        user_type: userType
      })
      .catch((error) => { 
        console.error('Error loading points leaderboard:', error);
        this.attrs.state.isLoading = false;
        this.attrs.state.hasLoaded = true;
        m.redraw();
        return null;
      })
      .then((results) => {
        if (results) {
          this.parseResults(results);
        }
      });
  }

  loadGroupResults() {
    // 如果已有数据，不显示 loading，在后台加载新数据
    const hasData = this.groupBoardList && this.groupBoardList.length > 0;
    if (!hasData && !this.attrs.state.isLoading) {
      this.attrs.state.isLoading = true;
    }

    const period = this.period;
    const limit = this.initloadCount;

    return app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/social-groups/heat-rank`,
      params: {
        period: period,
        page: {
          number: 1,
          limit: limit
        }
      }
    }).then((response) => {
      this.parseGroupResults(response);
    }).catch((error) => {
      console.error('Error loading group heat rank:', error);
      this.attrs.state.isLoading = false;
      this.groupBoardList = [];
      m.redraw();
    });
  }

  parseGroupResults(response) {
    try {
      let data = [];
      if (response.data && Array.isArray(response.data)) {
        data = response.data;
      } else if (Array.isArray(response)) {
        data = response;
      }

      if (Array.isArray(data) && data.length > 0) {
        this.groupBoardList = data;
      } else {
        this.groupBoardList = [];
      }

      this.attrs.state.isLoading = false;
      m.redraw();
    } catch (error) {
      console.error('Error parsing group results:', error);
      this.attrs.state.isLoading = false;
      this.groupBoardList = [];
      m.redraw();
    }
  }
}